<template>
  <div id="login_outer" class="container-fluid vue_body_min_height">
    <div id="logoin_card">
      <div id="login_card_top_menu">
        <a v-for="(item, index) in tabList"
            href="javascript:void(0);"
           :class="[index == tabIndex ? 'active' : '']"
           @click="tabIndexClicked(index)"
           :key="'login_menu_' + index"
        >{{item}}</a>
      </div>

      <div id="login_card_sub_menu">

<!--        <a v-for="(item, index) in subTabList"-->
<!--           v-if="tabIndex == 0"-->
<!--           :class="[subTabIndex == index ? 'active' : '']"-->
<!--           href="javascript:void(0);"-->
<!--           @click="subTabClicked(index)"-->
<!--           :key="'login_sub_menu_' + index"-->
<!--        >{{item}}</a>-->
      </div>

<!--      账号登录-->
      <div id="login_card_form" v-if="(tabIndex == 0 && subTabIndex == 1) || tabIndex == 1">
          <input type="text" v-model="userName" placeholder="请输入手机账号或者账号名称">
          <input type="password" v-model="userPwd" placeholder="请输入密码" @keyup.enter="passwordEnterKeyClicked">
          <a id="login_form_forget_pwd" :href="'/forgetpwd' + '/' + tabIndex">忘记密码?</a>
          <div style="clear: both;"></div>
          <input type="button" value="登录" id="login_card_btn" @click="userLogin">
      </div>

<!--      扫码登录-->
      <div id="login_card_pic_scan" v-else>
        <div v-if="this.isWeixin()">
          <el-button
            @click="wechatRequestButtonClicked"
            style="background-color: #fc1a34;color: white;min-width: 180px;font-size: 1rem;" round>点击授权</el-button>
        </div>
        <weixin-qr-code v-else></weixin-qr-code>
      </div>

      <div id="login_card_register">还没有账号？<a href="/register">去注册</a></div>

    </div>
    <div style="clear: both;"></div>
  </div>

</template>

<script>
import GlobalInstance from "../js/shba";
import WeixinQrCode from "../components/common/WeixinQrCode";
import WeixinManager from '../js/weixin.config';

export default {
  name: "LoginPage",
  components: {
    WeixinQrCode
  },
  data() {
      return {
        tabIndex: 0,
        subTabIndex: 1,
        tabList: [
          '个人登录',
          '团体登录',
        ],
        subTabList: [
          '微信登录',
          '账号密码登录',
        ],
        userName: '',
        userPwd: '',
      }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    }
  },

  mounted() {
    this.dealWithDataInit();
  },
  methods: {
    subTabClicked(index) {
      this.subTabIndex = index;
    },
    tabIndexClicked(index) {
      this.tabIndex = index;
    },
    passwordEnterKeyClicked() {
      let name = this.userName.removeBlanks();
      if (name == undefined || name == '') {
        return;
      }
      this.userLogin();
    },

    dealWithLoginSuccess(data) {
      let user = data.data;
      let isTeam = user.isTeam;
      let token = user.token;
      let nickName = user.nickname;
      let saveUser = {
        token: token,
        isTeam: isTeam,
        nickName: nickName,
        userId: user.id
      };
      let dataManager = this.$store.state.dataStore;
      dataManager.setUser(saveUser);

      let rediretUrl = dataManager.getRedirectUrl();
      if (rediretUrl != null) {
        if (rediretUrl.substr('/personal/center/certapplication') >= 0) {
          if (isTeam > 0) { // 团体账户
            this.$toast('团体账户无法进行身份认证！');
            let _this = this;
            setTimeout(function () {
              dataManager.setRedirectUrl(null);
              _this.$router.push({
                name: 'groupPage'
              });
            }, 1000);
            return;
          }
        }
        dataManager.setRedirectUrl(null);
        window.location.href = rediretUrl;
        return;
      }

      if (isTeam == 1) {
        this.$router.push({
          name: 'groupPage'
        });
      } else {
        this.$router.push({
          name: 'personalPage'
        });
      }
    },

    userLogin() {
      let name = this.userName.removeBlanks();
      if (name == undefined || name == '') {
        this.$toast('用户名不能为空');
        return;
      }

      let pwd = this.userPwd.removeBlanks();
      if (pwd == undefined || pwd == '') {
        this.$toast('密码不能为空');
        return;
      }

      let params = {
        name,
        password: pwd,
      }

      let _this = this;
      this.$store.state.http.ajax.userSignin(params,
        function (data) {
          if (data.code == 0) {
            _this.$toast('登录成功！');
            _this.dealWithLoginSuccess(data);
          } else {
            _this.$toast('用户名或密码错误，请重新输入！');
          }
      }, function (data) {
          _this.$toast('登录失败，请重试！');
      });
    },

    wxUserLogin(code, state, callback) {
      let params = {
        code: code
      };

      if (state == 1002) {
        params.pf = 'wx';
      } else {
        params.pf = 'pc';
      }

      let _this = this;
      this.httpManager.ajax.userQrconnect(params, function (data) {
        let code = data.code;
        if (code == 0) {
          let firstLoginByWXQR = data.data.firstLoginByWXQR;
          if (firstLoginByWXQR != undefined && firstLoginByWXQR == false) {
            _this.dealWithLoginSuccess(data);
          } else {
            callback(data);
          }
          return;
        }

        _this.$toast('数据加载失败');
      }, function (data) {
        _this.$toast('数据加载失败，请刷新');
      })
    },

    dealWithDataInit() {
      let query = this.$route.query;
      let state = query.state;
      let code = query.code;
      if (state != undefined || code != undefined) {
        if (code == undefined) {
          this.$toast('取消登录！');
        } else {
          let _this = this;
          this.wxUserLogin(code, state,function (data) {
            _this.$store.state.dataStore.setWeixinData(data.data);
            let newLocation = _this.$router.resolve({
              name: 'weixinLoginBind'
            });
            window.location.href = newLocation.href;
          });
        }
        return;
      }

      let token = this.$store.state.dataStore.getToken();
      if (token == null) {
        return;
      }
      if (token != null) {
        let _this = this;
        this.checkToken(this.$store,function (data) {
          let code = data.code;
          if (code == 0) {
            let user = _this.$store.state.dataStore.getUser();
            if (user.isTeam == 1) {
              _this.$router.push({
                name: 'groupPage'
              });
            } else {
              _this.$router.push({
                name: 'personalPage'
              });
            }
          }
        });
      }
    },

    wechatRequestButtonClicked() {
      console.log('微信点击授权！');
      let url = window.location.href;
      WeixinManager.jsapi_weixinLoginAutorize(url);
    }
  }
}
</script>

<style scoped>

  #login_outer {
    background-image: url("../assets/shl_login_bg.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center top;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: nowrap;
    background-color: rgb(15, 15,15);
  }

  #logoin_card {
    border-radius: 8px;
    background-color: white;
    padding-bottom: 30px;
    text-align: center;
  }

  @media (max-width: 374px){
    #login_outer {
      align-items: center;
    }

    #logoin_card {
      width: 300px;
    }
  }

  @media (min-width: 375px){
    #login_outer {
      align-items: center;
    }

    #logoin_card {
      width: 80%;
      min-width: 300px
    }
  }

  @media (min-width: 646px) {
    #login_outer {
      align-items: flex-end;
    }
    #logoin_card {
      width: 516px;
      margin-right: 10%;
    }
  }

  @media (min-width: 768px){
    #login_outer {
      align-items: flex-end;
    }
    #logoin_card {
      margin-right: 10%;
      width: 516px;
    }
  }

  @media (min-width: 992px) {
    #login_outer {
      align-items: flex-end;
    }
    #logoin_card {
      margin-right: 10%;
      width: 516px;
    }
  }

  @media (min-width: 1200px) {
    #login_outer {
      align-items: flex-end;
    }

    #logoin_card {
      margin-right: 10%;
      width: 516px;
    }
  }

  #login_card_top_menu {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 0;
    padding-bottom: 15px;
  }

  #login_card_top_menu a:first-child {
    border-top-left-radius: 8px;
  }

  #login_card_top_menu a:last-child {
    border-top-right-radius: 8px;
  }

  #login_card_top_menu > a {
    width: 50%;
    color: white;
    background-color: #fc1a34;
    vertical-align: middle;
    line-height: 86px;
    height: 80px;
    font-weight: bold;
    font-size: 1.5rem;
    text-decoration: none;
  }

  #login_card_top_menu > a.active {
    background-color: white;
    color: black;
    pointer-events: none;
  }

  #login_card_form {
    width: 100%;
    padding: 0 15px 20px 15px;
  }

  @media screen and (min-width: 768px){
    #login_card_form {
      width: 100%;
      padding: 0 60px 30px 60px;
    }
  }

  #login_card_form input {
    background-color: #eee;
    height: 48px;
    border-radius: 25px;
    border: solid 1px transparent;
    color: black;
    outline: none;
    display: block;
    width: 100%;
    margin-top: 30px;
    text-indent: 15px;
    font-size: 1rem;
    letter-spacing: 1.5px;
  }

  #login_card_form #login_card_btn {
    text-indent: 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    background-color: #fc1a34;
  }

  #login_card_form input::-webkit-input-placeholder {
    color: #999;
  }

  #login_form_forget_pwd {
    color: #666;
    float: right;
    margin-right: 30px;
    font-size: 0.8rem;
    margin-top: 15px;
    text-decoration: none;
  }

  #login_form_forget_pwd:hover {
    color: #333;
  }


  #login_card_register {
    font-size: 0.8rem;
    color: #333;
  }

  #login_card_register a {
    color: #fc1a34;
    text-decoration: none;
  }

  #login_card_register a:hover {
    color: #111;
  }

  #login_card_sub_menu {
    height: 30px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  #login_card_sub_menu a {
    color: #333;
    font-size: 0.8rem;
    text-decoration: none;
  }

  #login_card_sub_menu a.active, #login_card_sub_menu a:hover {
    color: #fc1a34;
   }

  #login_card_sub_menu a.active {
    pointer-events: none;
  }

  #login_card_pic_scan {
    margin-top: 15px;
    padding-bottom: 30px;
    height: 280px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #login_card_pic_scan img {
    width: auto;
    height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue